import { useContext, createContext } from "react";

export const SettingsContext = createContext({
  change: (value) => null,
});

export const useSettings = () => useContext(SettingsContext);
